import React from 'react'

import Button from 'components/Form/Button'
import FormCore from 'components/Form/Core'
import FormSuccess from 'components/FormSuccess'
import TermCheck from 'components/TermCheck'
import ContainerUnauthenticated from 'containers/Unauthenticated'
import { ButtonContainer } from 'ui/styled'

import useController from './controller'
import {
    EventCard,
    EventEyebrow,
    EventLead,
    EventTitle,
    FormFooter,
    FormIntro,
    PrivacyLink,
} from './styled'

export default function BrazilNeuromodulationEvent() {
    const {
        formItems,
        formRef,
        loading,
        newsletterOptIn,
        privacyPolicyOptIn,
        success,
        setNewsletterOptIn,
        setPrivacyPolicyOptIn,
        submit,
        openLiteLogin,
    } = useController()

    return (
        <>
            {success ? (
                <FormSuccess
                    noHeader
                    actionLabel="Acessar o Universe Lite"
                    success={{
                        title: 'Inscrição recebida',
                        text: 'Obrigada! Seu acesso ao MagVenture Universe Lite está sendo preparado. Confira seu e-mail para receber as próximas instruções.',
                        action: openLiteLogin,
                    }}
                />
            ) : (
                <ContainerUnauthenticated noHeader>
                    <EventCard>
                        <EventEyebrow>MagVenture Universe Lite</EventEyebrow>
                        <EventTitle>Seja bem-vindo(a)!</EventTitle>
                        <EventLead>Cadastre-se para receber mais informações sobre pesquisas, estudos e acesso a conteúdos selecionados do MagVenture Universe Lite.</EventLead>

                        <FormIntro>Seus dados nos ajudam a preparar seu acesso e entrar em contato sobre o evento.</FormIntro>
                        <FormCore ref={formRef} formItems={formItems} />

                        <FormFooter>
                            <TermCheck
                                title="Desejo receber novidades da MagVenture e atualizações sobre o evento."
                                value={newsletterOptIn}
                                onChange={setNewsletterOptIn}
                            />
                            <TermCheck
                                title="Li e aceito a"
                                text="Política de Privacidade"
                                value={privacyPolicyOptIn}
                                onChange={setPrivacyPolicyOptIn}
                                link={() => window.open('/policy.pdf', '_blank')}
                            />
                            <PrivacyLink>Ao enviar este formulário, você concorda que a MagVenture trate suas informações para realizar sua inscrição.</PrivacyLink>
                        </FormFooter>

                        <ButtonContainer center>
                            <Button color="blue" width="260px" loading={loading} disabled={loading} onClick={submit}>Cadastrar interesse</Button>
                        </ButtonContainer>
                    </EventCard>
                </ContainerUnauthenticated>
            )}
        </>
    )
}
